import React from 'react';

const LoansIcon = ({ stroke }) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.82416 2.3418H5.3895C4.01683 2.3418 2.8335 3.45446 2.8335 4.8278V11.9858C2.8335 13.4365 3.93883 14.5771 5.3895 14.5771H10.7148C12.0882 14.5771 13.2015 13.3591 13.2015 11.9858V5.85913L9.82416 2.3418Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.64917 2.33398V4.27332C9.64917 5.21998 10.4152 5.98798 11.3618 5.98998C12.2392 5.99198 13.1372 5.99265 13.1978 5.98865" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.76034 6.79395V11.1759" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.86816 8.69461L7.76016 6.79395L9.65283 8.69461" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default LoansIcon;
